import { useLingui } from '@lingui/react/macro';
import { Login } from './app/Login';
import { PrivateRoute } from './app/PrivateRoute';
import { DashboardRoute } from './dashboard/DashboardRoute';
import { PaymentCompleted } from './dashboard/PaymentCompleted';
import { AppLayout } from './layout/AppLayout';
import { MenuItem } from './layout/MenuItem';
import { CourseReservationView } from './student/CourseReservationView';
import { getConfig } from './utils/config';
import { PageTitleProvider } from '@enroller/utils';
import { Route, Routes, useLocation } from 'react-router-dom';

export const AppRoutes = () => {
  const { pageTitlePrefix } = getConfig();
  const { pathname } = useLocation();
  const { t } = useLingui();

  const dashboardMenuItems = (onMenuItemClick?: () => void) => (
    <>
      <MenuItem label={t`Home`} href="/" onClick={onMenuItemClick} />
      <MenuItem label={t`Course Reservation`} href="/course-reservation" last />
    </>
  );
  const studentMenuItems = (onMenuItemClick?: () => void) => (
    <>
      <MenuItem label={t`Student Details`} href="/course-reservation#student-details" onClick={onMenuItemClick} />
      <MenuItem label={t`Parent / Guardian 1 Details`} href="/course-reservation#guardian-1" onClick={onMenuItemClick} />
      <MenuItem label={t`Parent / Guardian 2 Details`} href="/course-reservation#guardian-2" onClick={onMenuItemClick} />
      <MenuItem label={t`Additional Information`} href="/course-reservation#additional-information" onClick={onMenuItemClick} />
      <MenuItem label={t`Program`} href="/course-reservation#program" last onClick={onMenuItemClick} />
    </>
  );

  return (
    <PageTitleProvider pageTitlePrefix={pageTitlePrefix} pathname={pathname}>
      <PrivateRoute>
        <Routes>
          <Route element={<AppLayout menuItems={dashboardMenuItems} />}>
            <Route index element={<DashboardRoute />} />
            <Route path="login" element={<Login />} />
            <Route path="callback" element={<></>} />
            <Route path="payment-complete" element={<PaymentCompleted />} />
          </Route>
          <Route element={<AppLayout menuItems={studentMenuItems} breadcrumb={t`Course Reservation`} />}>
            <Route path="course-reservation" element={<CourseReservationView />} />
          </Route>
        </Routes>
      </PrivateRoute>
    </PageTitleProvider>
  );
};
